import { render, staticRenderFns } from "./StatusIcons.vue?vue&type=template&id=b734ec74&scoped=true&"
import script from "./StatusIcons.vue?vue&type=script&lang=js&"
export * from "./StatusIcons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b734ec74",
  null
  
)

export default component.exports